import React, { useState, useRef } from "react";
import { Container, Row, Col, Form, Card, Button } from "react-bootstrap";
import "./ProfileEdit.css";
import CommonBreadcrumb from "./../../../common_components/breadcrumb/CommonBreadcrumb";
import WhiteButton from "./../../../common_components/common_button/WhiteButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import SuccessModal from "./../../../common_components/common_modal/profile_succes_modal/ProfileSucces";

const ProfileSettings = () => {
  const [showModal, setShowModal] = useState(false);

  const handleSaveChanges = () => {
    // 👉 Put API call here if needed
    setShowModal(true);
  };

  const breadcrumbItems = [
    { label: "Profile", link: "/profile" },
    { label: "Profile Settings", link: "/profile-settings" },
    { label: "Edit Profile" },
  ];
  const fileInputRef = useRef(null);
  const [profileImage, setProfileImage] = useState(null);

  const handleEditClick = () => {
    fileInputRef.current.click();
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setProfileImage(imageUrl);
    }
  };

  return (
    <section className="profile-setting-section profile-edit-section">
      <CommonBreadcrumb items={breadcrumbItems} />
      <div className="profile-wrapper">
        <Container>
          <p className="text-center text-muted mb-5">
            Update your personal details & manage your account preferences.
          </p>

          <Card className="profile-card shadow-sm border-0">
            {/* Avatar */}
            <div className="profile-image-wrapper">
              <div className="first-border">
                <div className="second-border">
                  <div className="profile-image">
                    {profileImage ? (
                      <img src={profileImage} alt="Profile" />
                    ) : (
                      "PP"
                    )}
                  </div>
                </div>
              </div>

              <div className="edit-icon" onClick={handleEditClick}>
                <FontAwesomeIcon icon={faPen} />
              </div>

              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                onChange={handleImageChange}
                hidden
              />
            </div>

            <Card.Body className=" profile-card-body">
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Contact No.</Form.Label>
                  <Form.Control
                    type="text"
                    defaultValue="+91 3678927381"
                    className="rounded-pill "
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Full name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="eg. sarah jamdar"
                    className="rounded-pill"
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Email Address (Optional)</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="eg. sarahjamdar@example.com"
                    className="rounded-pill"
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Street address</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="eg. Akshya Nagar 1st Block 1st Cross, Ramurthy Nagar, Bangalore -560016"
                    className="rounded-4"
                  />
                </Form.Group>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>City</Form.Label>
                      <Form.Select className="rounded-pill">
                        <option>Pune</option>
                        <option>Mumbai</option>
                        <option>Bangalore</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Zipcode</Form.Label>
                      <Form.Select className="rounded-pill">
                        <option>413501</option>
                        <option>400001</option>
                        <option>560016</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-4">
                  <Form.Check
                    type="checkbox"
                    label="Save this address for delivery of your order"
                    className="form-checkbox"
                  />
                </Form.Group>

                <div className="text-center">
                  <WhiteButton
                    title={"Save Changes"}
                    bg="#010E1E"
                    color="#f35f37"
                    hoverColor="#f35f37"
                    hoverBg={"#010E1E"}
                    onClick={handleSaveChanges}
                  />
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Container>
      </div>
      <SuccessModal show={showModal} handleClose={() => setShowModal(false)} />
    </section>
  );
};

export default ProfileSettings;
